import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Css/FeaturedCollection.module.css";
import { collectionsData } from "../../data/collectionData";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const FeaturedCollections = () => {
  const navigate = useNavigate();

  // Array of background images (now using paths from public directory)
  const backgroundImages = [
    "/images/garhwali.webp",
    "/images/love.webp",
    "/images/horror.webp",
    "/images/crime.webp",
    "/images/kids.webp",
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Featured Collections</h2>

      <div className={styles.swiperWrapper}>
        <Swiper
          spaceBetween={15}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 0.8,
            momentumVelocityRatio: 0.8,
            minimumVelocity: 0.02,
          }}
          modules={[Mousewheel, FreeMode]}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1.5,
            releaseOnEdges: true,
          }}
          speed={600}
          resistance={false}
          resistanceRatio={0}
          className={styles.swiper}
          breakpoints={{
            320: {
              slidesPerView: 1.5,
              spaceBetween: 5,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
        >
          {collectionsData.map((collection, index) => (
            <SwiperSlide key={collection.id}>
              <div
                onClick={() => navigate(`/collection/${collection.link}`)}
                className={styles.card}
                style={{
                  backgroundImage: ` url(${
                    backgroundImages[index % backgroundImages.length]
                  })`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className={styles.content}>
                  <div className={styles.titleContainer}>
                    <p className={styles.title}>{collection.title}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default FeaturedCollections;
